module.exports = __webpack_public_path__ + "img/Lendio-Ad-2.c0e8c5a5.png";